var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-text"},[_c('van-image',{staticClass:"img-box",attrs:{"src":_vm.imgUrl,"fit":"cover"}}),_c('van-image',{staticClass:"button",attrs:{"src":_vm.btnImg},on:{"click":_vm.jumpApplet}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }